import { catalogStore } from '../stores';
import { sha256 } from 'js-sha256';

export const useTrackingEvents = () => {
	const { userId } = catalogStore;

	const eventNameMap = {
		fbq: {
			add_to_cart: 'AddToCart',
			initiate_checkout: 'InitiateCheckout',
			checkout: 'Purchase',
			lead: 'Lead',
			page_visit: 'ViewContent',
			search: 'Search',
		},
		pinterest: {
			add_to_cart: 'add_to_cart',
			initiate_checkout: 'initiate_checkout',
			checkout: 'checkout',
			lead: 'lead',
			page_visit: 'page_visit',
			search: 'search',
		},
		gtm: {
			add_to_cart: 'add_to_cart',
			initiate_checkout: 'initiate_checkout',
			checkout: 'checkout',
			lead: 'lead',
			page_visit: 'page_visit', // use for product viewed
			search: 'search',
		},
	};

	const epik = document.cookie
		.split('; ')
		.find(row => row.startsWith('_epik='))
		?.split('=')[1];

	const sendTrackingEvent = (internalEventName, eventData) => {
		const fbqName = eventNameMap.fbq[internalEventName];
		const pinterestName = eventNameMap.pinterest[internalEventName];
		const gtmName = eventNameMap.gtm[internalEventName];

		// Facebook Pixel
		if (window.fbq && fbqName) {
			window.fbq('track', fbqName, {
				...eventData,
				...(userId && { external_id: sha256(userId) }),
			});
		}

		// Google Tag Manager
		if (window.dataLayer && gtmName) {
			window.dataLayer.push({
				event: gtmName,
				...eventData,
				...(userId && { user_id: sha256(userId) }),
			});
		}

		// Pinterest
		if (window.pintrk && pinterestName) {
			window.pintrk('track', pinterestName, {
				...eventData,
				...(userId && { external_id: sha256(userId) }),
				...(epik && { click_id: epik }),
			});
		}

		// Optional: Logging
		// console.log(`[Tracking] ${internalEventName}`, eventData);
	};

	return { sendTrackingEvent };
};
